import { render, staticRenderFns } from "./SettlementsRules.vue?vue&type=template&id=6a2b6902&scoped=true"
import script from "./SettlementsRules.vue?vue&type=script&lang=js"
export * from "./SettlementsRules.vue?vue&type=script&lang=js"
import style0 from "./SettlementsRules.vue?vue&type=style&index=0&id=6a2b6902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b6902",
  null
  
)

export default component.exports